module.exports = __webpack_public_path__ + "img/safe_tool_02.a2c3d149.png";